import { WidgetTypes } from 'types'

export const FEATURE_NAME = 'init'

export const DEFAULT_TITLE_FONT_SIZE = 34

export interface IState {
  widgetType: WidgetTypes | null
  title: string | null
  titleFontSize: number
  seeAllScoresButton: boolean
  backgroundImage: string | null
}
